module.exports = __webpack_public_path__ + "img/Sint Maarten.9d5450f7.svg";